/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldOption } from './fieldOption';

/**
 * A FieldSchema can guide and direct each input field of the application process, which can be customized with different formats and validations. A FieldSchema can be reused by multiple StageSchemas.
 */
export interface FieldSchema { 
    /**
     * An unique ID for a FieldSchema, which can be self-descriptive for admin to understand and use.
     */
    id: string;
    /**
     * Internal used for developers/admins to manage, or for ETL name to map and convert the data by Name.
     */
    name: string;
    /**
     * Lable of the field, which will be shown on the UI.
     */
    label: string;
    /**
     * Tooltips of the field, which will popup when hovered.
     */
    tooltip: string;
    /**
     * True for required columns, which will be checked before marking the stage as completed.
     */
    isRequired?: boolean;
    /**
     * When it's readonly like LabelField, there's no input needed to persist to Prospect entity. No data to save to Prospect Data entity. 
     */
    isReadOnly?: boolean;
    /**
     * When the field is predefined for the user to select. The id of factory fields will not be changed.
     */
    isFactoryField?: boolean;
    /**
     * Enum value of TextStyle.
     */
    textStyle?: FieldSchema.TextStyleEnum;
    /**
     * Enum value of FieldType.
     */
    fieldType: FieldSchema.FieldTypeEnum;
    fieldOption?: FieldOption;
    /**
     * Percentage of the field (default as 100%)
     */
    width?: string;
    /**
     * Margin of the field (default as 0)
     */
    margin?: string;
    /**
     * Default to be empty which means admin | external | both
     */
    viewedBy?: string;
}
export namespace FieldSchema {
    export type TextStyleEnum = 'Head1' | 'Head2' | 'Head3' | 'Head4' | 'Head5' | 'Head6' | 'Normal';
    export const TextStyleEnum = {
        Head1: 'Head1' as TextStyleEnum,
        Head2: 'Head2' as TextStyleEnum,
        Head3: 'Head3' as TextStyleEnum,
        Head4: 'Head4' as TextStyleEnum,
        Head5: 'Head5' as TextStyleEnum,
        Head6: 'Head6' as TextStyleEnum,
        Normal: 'Normal' as TextStyleEnum
    };
    export type FieldTypeEnum = 'LabelField' | 'StringField' | 'DecimalField' | 'IntegerField' | 'BooleanField' | 'DateTimeField' | 'DropdownField' | 'GroupField' | 'DocumentField' | 'EditPhoneField' | 'AddDocumentField' | 'AddDocumentListField' | 'DownloadAllDocumentsField';
    export const FieldTypeEnum = {
        LabelField: 'LabelField' as FieldTypeEnum,
        StringField: 'StringField' as FieldTypeEnum,
        DecimalField: 'DecimalField' as FieldTypeEnum,
        IntegerField: 'IntegerField' as FieldTypeEnum,
        BooleanField: 'BooleanField' as FieldTypeEnum,
        DateTimeField: 'DateTimeField' as FieldTypeEnum,
        DropdownField: 'DropdownField' as FieldTypeEnum,
        GroupField: 'GroupField' as FieldTypeEnum,
        DocumentField: 'DocumentField' as FieldTypeEnum,
        EditPhoneField: 'EditPhoneField' as FieldTypeEnum,
        AddDocumentField: 'AddDocumentField' as FieldTypeEnum,
        AddDocumentListField: 'AddDocumentListField' as FieldTypeEnum,
        DownloadAllDocumentsField: 'DownloadAllDocumentsField' as FieldTypeEnum
    };
}